import _slicedToArray from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState } from 'react';
export default (function () {
  var ms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      ready = _useState2[0],
      setReady = _useState2[1];

  useEffect(function () {
    var unmounted = false;
    var timer = setTimeout(function () {
      if (!unmounted) {
        setReady(true);
      }
    }, ms);
    return function () {
      unmounted = true;
      clearTimeout(timer);
    };
  }, [ms]);
  return ready;
});